








































import { Component, Vue } from 'vue-property-decorator';
import t from '@/i18n/translations';
import { State, Action, Getter, Mutation } from 'vuex-class';

@Component({ })
export default class Header extends Vue {
    @Action('logout', {namespace: 'user'}) logout;
    @Getter('getIsLogged', {namespace: 'user'}) getIsLogged;

    i18n = t['nl'];

    logoutAction(e) {
        e.preventDefault();
        this.logout();
        this.$router.push('/')
    }
}
